<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="1" AllActive />
    <iRightFixedBox />
    <iPageTitle :text="pageTitle" />
    <div class="mine">
      <van-row type="flex">
        <van-col span="4" class="left-nav">
          <ul>
            <li v-for="(item) in leftNavData" :key="item.key">
              <div>
                <van-icon :name="require('@/assets/mine/'+item.icon+'.png')" size="24px" v-if="item.icon" />
                {{item.name}}
              </div>
              <ul>
                <li v-for="(v) in item.child" :key="v.key" @click.stop="handleNav(item,v)" :class="{'actived':activedKey == v.key}">
                  {{v.name}}
                  <span v-if="v.name == '门店资质'&&QualificationCount">{{QualificationCount>99?'99+':QualificationCount}}</span>
                  <span v-if="v.name == '消息通知'&&customerMsgCount">{{customerMsgCount>99?'99+':customerMsgCount}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </van-col>
        <van-col span="20">
          <component :is="activedUrl"></component>
        </van-col>
      </van-row>
    </div>
    <iFooter />
  </div>
</template>

<script>
  import iHeader from "@/components/Header";
  import iNav from "@/components/Nav";
  import iClassify from "@/components/Classify";
  import iPageTitle from "@/components/PageTitle";
  import iFooter from "@/components/Footer";
  import iRightFixedBox from "@/components/RightFixedBox";
  import { BaseMixin } from "../../mixins/BaseMixin";
  export default {
    name: "HelpCenter",
    mixins: [BaseMixin],
    components: {
      iHeader,
      iNav,
      iFooter,
      iRightFixedBox,
      iClassify,
      iPageTitle
    },
    data() {
      return {
        pageTitle: ["交易管理", "帮助中心"],
        QualificationCount: 0,
        customerMsgCount: 0,
        leftNavData: [
        {
          name: "新手指南",
          icon: "left-nav-wodezhanghu-icon",
          key: "1",
          child: [
          {
            name: "用户注册",
            url: "",
            key: "11"
          },
          {
            name: "用户登录",
            url: "",
            key: "12"
          },
          {
            name: "采购指南",
            url: "",
            key: "13"
          },
          {
            name: "首营认证",
            url: "",
            key: "14"
          }]
        },
        {
          name: "售后服务",
          icon: "left-nav-jiaoyiguanli-icon",
          key: "2",
          child: [
          {
            name: "退款流程",
            url: "",
            key: "21"
          },
          {
            name: "退货流程",
            url: "",
            key: "22"
          },
          {
            name: "订单开票",
            url: "",
            key: "23"
          }]
        },
        {
          name: "常见问题",
          icon: "left-nav-wodeshoucang-icon",
          key: "3",
          child: [
          {
            name: "优惠券使用",
            url: "",
            key: "31"
          },
          {
            name: "限额说明",
            url: "",
            key: "32"
          },
          {
            name: "支付方式",
            url: "",
            key: "33"
          },
          {
            name: "门店切换",
            url: "",
            key: "34"
          }]
        },
        {
          name: "关于我们",
          icon: "left-nav-bangzhuzhongxin-icon",
          key: "4",
          child: [
          {
            name: "平台介绍",
            url: "",
            key: "41"
          },
          {
            name: "用户协议",
            url: "",
            key: "42"
          }]
        }],
        activedParentKey: 1,
        activedKey: 11,
        activedUrl: ""
      };
    },
    created() {},
    mounted() {},
    methods: {
      handleNav(p, c) {
        this.activedParentKey = p.key;
        this.activedKey = c.key;
        this.activedUrl = c.url;
        this.pageTitle = [p.name, c.name];
      }
    }
  };
</script>

<style scoped lang="less">
  .mine {
    margin: 0 auto 80px auto;
    margin-top: 28px;
    width: 1200px;
    font-size: 16px;
  }

  .actives {
    padding: 20px;
    background-color: #ffeeec;
  }

  .active {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 15px;

    &:first-child {
      margin-top: 0px;
    }

    .tag {
      color: #ffffff;
      background: linear-gradient(166deg,
          rgba(255, 134, 57, 1) 0%,
          rgba(255, 71, 71, 1) 100%);
      border-radius: 2px;
      font-size: 14px;
      padding: 2px 7px;
    }

    .content {
      margin-left: 15px;
      color: #777777;
    }
  }

  .goods-title {
    margin-top: 21px;
    width: 1200px;
    background: rgba(245, 245, 245, 1);
    box-sizing: border-box;
    height: 50px;
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    font-size: 16px;
    color: #222222;

    .checkall {
      margin-left: 20px;
    }

    .name {
      position: absolute;
      left: 254px;
    }

    .name {
      position: absolute;
      left: 254px;
    }

    .price {
      position: absolute;
      left: 607px;
    }

    .amount {
      position: absolute;
      left: 800px;
    }

    .total {
      position: absolute;
      left: 981px;
    }

    .action {
      position: absolute;
      left: 1122px;
    }
  }

  .goods-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .itm {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    .gactive {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .left-nav {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(232, 232, 232, 1);
    width: 240px;

    >ul {
      padding-bottom: 6px;
      width: 238px;

      >li {
        font-size: 18px;
        font-weight: 600;
        color: #222;
        padding: 18px 0 5px 0;
        text-align: left;

        >div {
          position: relative;
          padding: 0 28px 0 60px;
          margin-bottom: 15px;

          /deep/.van-icon {
            position: absolute;
            left: 28px;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        >ul {
          >li {
            padding: 15px 28px 15px 60px;
            font-size: 16px;
            font-weight: 400;
            line-height: 1.3;
            cursor: pointer;

            >span {
              display: inline-block;
              width: 28px;
              height: 19px;
              background: rgba(255, 57, 57, 1);
              border-radius: 10px;
              font-size: 12px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              text-align: center;
              line-height: 19px;
              position: relative;
              left: 4px;
              top: -10px;
            }
          }

          >li.actived {
            border-left: 4px solid #0f6ee9;
            background: linear-gradient(78deg,
                rgba(232, 242, 255, 1) 0%,
                rgba(255, 255, 255, 1) 100%);
            padding-left: 56px;
          }
        }
      }
    }
  }
</style>